import { CartModel } from './models';

export const state = {
  cart: new CartModel(),
  coupon: null,
  couponInputVisible: false,
  showUsOnlyMessage: false,
};

export const mutations = {

};